import React, {useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import { Elements } from 'react-stripe-elements';
import Link from '@material-ui/core/Link';
import Switch from '@material-ui/core/Switch';
import { COLORS } from '../../styles/colors'
import MakePayment from './makePayment';
import { PLANOPTION } from '../../constants'

const useStyles = makeStyles((theme) => ({
  section: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  cardHeader: {
    paddingTop: theme.spacing(3),
    paddingBottom: '2px !important'
  },
  headerTitle: {
    fontWeight: 'bold',
    fontSize: 22
  },
  paraContent: {
    'fontSize': '12px',
    'fontWeight': 'bold',
    'textAlign': 'left'
  }
}));

export default function Pricing(props) {

  const classes = useStyles();

  const [ openPaymentModal, setOpenPaymentModal] = useState(false);

  const [ isShowContent, setShowContent] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowContent(true)
    }, 2000)
  }, [])

  
  let content = {
    'header-p1': 'Upgrade and do more',
    'description': 'Simple, affordable pricing with no contracts or obligations', 
    '01_title': 'Professional',
    '01_price': '$10 per month',
    '01_benefit1': 'Unlimited clients',
    '01_benefit2': 'Easily assign workouts and programs to individuals or groups within minutes',
    '01_plan': PLANOPTION.ONE,
    '00_title': 'Free Forever',
    '00_price': '',
    '00_benefit1': 'Your own branded home page',
    '00_benefit2': 'Build and share unlimited workouts and programs to your home page',
    '00_benefit3': 'Exercise library sharing',
    '00_benefit4': 'Social channel to grow your community',
    '00_benefit5': 'Unlimited assigning of tasks and action plans to clients',
    '00_benefit6': 'PAR-Q access',
    '00_benefit7': 'Unlimited access to Functional Strength Screen assessment and measuring tool',
    '00_plan': 1,
    '00_height': 310,
    
    
    '01_primary-action': 'Get started',
    '02_title': 'Professional Plus',
    '02_price': '$25 per month',
    '02_benefit1': 'Unlimited clients',
    '02_benefit2': 'Easily assign workouts and programs to individuals or groups within minutes',
    '02_benefit3': 'Send messages, images, and videos with build in chat',
    '02_benefit4': 'Unlimited push notifications to clients',
    '02_benefit5': 'Message automation features',
    '02_benefit6': 'Send scheduled messages and reminders',
    '02_primary-action': 'Get started',
    '02_plan': PLANOPTION.TWO,
    ...props.content
  };

  const [planOption, setPlanOption] = useState(content['01_plan']);


  if(props.isAgency && !props.isNCEP) {
    content = {
      'header-p1': 'Spend less, do more',
      'description': 'Simple, affordable pricing with no contracts or obligations', 
      '01_title': 'Professional',
      '01_price': '$59 per month',
      '01_benefit1': 'Unlimited clients',
      '01_benefit2': 'Easily assign workouts and programs to individuals or groups within minutes',
      '01_plan': PLANOPTION.FOUR,
      '00_title': 'Basic',
      '00_price': '$49 per month',
      '00_benefit1': 'Your own branded home page',
      '00_benefit2': 'Build and share unlimited workouts and programs to your home page',
      '00_benefit3': 'Exercise library sharing',
      '00_benefit4': 'Social channel to grow your community',
      '00_benefit5': 'Unlimited assigning of tasks and action plans to clients',
      '00_benefit6': 'PAR-Q access',
      '00_benefit7': 'Unlimited access to Functional Strength Screen assessment and measuring tool',
      '00_plan': 3,
      '00_primary-action': 'Get started',
      '00_height': 270,
      
      '01_primary-action': 'Get started',
      '02_title': 'Professional Plus',
      '02_price': '$69 per month',
      '02_benefit1': 'Unlimited clients',
      '02_benefit2': 'Easily assign workouts and programs to individuals or groups within minutes',
      '02_benefit3': 'Send messages, images, and videos with build in chat',
      '02_benefit4': 'Unlimited push notifications to clients',
      '02_benefit5': 'Message automation features',
      '02_benefit6': 'Send scheduled messages and reminders',
      '02_primary-action': 'Get started',
      '02_plan': PLANOPTION.FIVE,
    }
  }

  const selectPlan = (option) => {
    setPlanOption(option)
    setOpenPaymentModal(true);
  }

  const hideMakePaymentModal = () => {
    setOpenPaymentModal(false);
  }

  const { currentUser } = props;

  if(!isShowContent) {
    return null
  }

  return (
    <section className={classes.section}>
      <Container maxWidth="lg">
        <Box  py={2} textAlign="center">
          <Box  mb={3}>
            <Container maxWidth="sm">
              <Typography variant="h3" component="h2" gutterBottom={true}>
                <Typography variant="h3" component="span" color="primary" style={{
                    color: COLORS.black
                }}>{content['header-p1']} </Typography>
              </Typography>
              <Typography variant="subtitle1" color="textSecondary" paragraph={true}>{content['description']}</Typography>

           
            </Container>
          </Box>
          <Grid  container spacing={3}>
          <Grid  item xs={12} md={4} style={{
                opacity: currentUser && currentUser.planOption === content['00_plan'] ? '0.5' : 1
              }}>
              <Card variant="outlined">
                <CardHeader title={content['00_title']} classes={{
                    title: classes.headerTitle
                }} className={classes.cardHeader}>
                </CardHeader>
                <Typography variant="h3" style={{
                  marginBottom: 20
                }} component="h2" gutterBottom={true}>
                      &nbsp;{content['00_price']}
                    </Typography>
                
                <CardContent>
                  <Box height={content['00_height']} px={1}>
                  <Typography variant="h3" component="h2" style={{
                    marginBottom: 10
                  }} gutterBottom={true}>
                    </Typography>
                    <Typography color="textSecondary" variant="subtitle1" className={classes.paraContent} component="li">{content['00_benefit1']}</Typography>
                    <Typography color="textSecondary" variant="subtitle1" className={classes.paraContent}  component="li">{content['00_benefit2']}</Typography>
                    <Typography color="textSecondary" variant="subtitle1" className={classes.paraContent}  component="li">{content['00_benefit3']}</Typography>
                    <Typography color="textSecondary" variant="subtitle1" className={classes.paraContent}  component="li">{content['00_benefit4']}</Typography>
                    <Typography color="textSecondary" variant="subtitle1" className={classes.paraContent}  component="li">{content['00_benefit5']}</Typography>
                    <Typography color="textSecondary" variant="subtitle1" className={classes.paraContent}  component="li">{content['00_benefit6']}</Typography>
                    <Typography color="textSecondary" variant="subtitle1" className={classes.paraContent}  component="li">{content['00_benefit7']}</Typography>
                  
                  </Box>
                  { (props.isAgency && !props.isNCEP) &&
                    <Button variant="contained" 
                    style={{
                        backgroundColor: COLORS.orange,
                        color: COLORS.white
                    }} disabled={currentUser && currentUser.planOption === content['00_plan']} onClick={() => selectPlan(content['00_plan'])}>{ currentUser && currentUser.planOption === content['00_plan'] ? 'Selected' : content['00_primary-action']}</Button>
                  }
                  </CardContent>
                  
              </Card>
            </Grid>


            <Grid  item xs={12} md={4} style={{
                opacity: currentUser && currentUser.planOption === content['01_plan'] ? '0.5' : 1
              }}>
              <Card variant="outlined">
                <CardHeader title={content['01_title']} classes={{
                    title: classes.headerTitle
                }} className={classes.cardHeader}>
                </CardHeader>
                <Typography variant="h3" component="h2" gutterBottom={true}>
                      {content['01_price']}
                    </Typography>
                
                <CardContent>
                  <Box height={300} px={1}>
                  <Typography variant="h3" component="h2" style={{
                    marginBottom: 10
                  }} gutterBottom={true}>
                     { (props.isAgency && !props.isNCEP) ?
                         'Everything in Basic plus': 'Everything in Free plus'
                     }
                    </Typography>
                    <Typography color="textSecondary" variant="subtitle1" className={classes.paraContent} component="li">{content['01_benefit1']}</Typography>
                    <Typography color="textSecondary" variant="subtitle1" className={classes.paraContent}  component="li">{content['01_benefit2']}</Typography>
                  </Box>
                  <Button variant="outlined" style={{
                      backgroundColor: COLORS.orange,
                      color: COLORS.white
                  }} disabled={currentUser && currentUser.planOption === content['01_plan']} onClick={() => selectPlan(content['01_plan'])}  className={classes.primaryAction}>{ currentUser && currentUser.planOption === content['01_plan'] ? 'Selected' : content['01_primary-action'] }</Button>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4} style={{
                opacity: currentUser && currentUser.planOption === content['02_plan'] ? '0.5' : 1
              }}>
              <Card variant="outlined">
                <CardHeader title={content['02_title']} classes={{
                    title: classes.headerTitle
                }}  className={classes.cardHeader}></CardHeader>
                <Typography variant="h3" component="h2" gutterBottom={true}>
                      {content['02_price']}
                    </Typography>
                <CardContent>
                  <Box height={295} px={1}>
                  <Typography variant="h3" component="h2" style={{
                    marginBottom: 10
                  }} gutterBottom={true}>
                         Everything in Professional Plus: 
                    </Typography>
                    <Typography color="textSecondary" className={classes.paraContent}  variant="subtitle1" component="li">{content['02_benefit1']}</Typography>
                    <Typography color="textSecondary" className={classes.paraContent}  variant="subtitle1" component="li">{content['02_benefit2']}</Typography>
                    <Typography color="textSecondary" className={classes.paraContent}  variant="subtitle1" component="li">{content['02_benefit3']}</Typography>
                    <Typography color="textSecondary" className={classes.paraContent}  variant="subtitle1" component="li" >{content['02_benefit4']}</Typography>
                    <Typography color="textSecondary" className={classes.paraContent} variant="subtitle1" component="li" >{content['02_benefit5']}</Typography>
                    <Typography color="textSecondary" className={classes.paraContent}  variant="subtitle1" component="li">{content['02_benefit6']}</Typography>
                 
                  </Box>
                  <Button variant="contained" 
                  style={{
                      backgroundColor: COLORS.orange,
                      color: COLORS.white
                  }} disabled={currentUser && currentUser.planOption === content['02_plan']} onClick={() => selectPlan(content['02_plan'])}>{ currentUser && currentUser.planOption === content['02_plan'] ? 'Selected' : content['02_primary-action']}</Button>
                 
                </CardContent>
              </Card>
            </Grid>
           
          </Grid>
        </Box>
        {openPaymentModal && <Elements><MakePayment {...props} show={openPaymentModal} planOption={planOption} hidePaymentMethod={hideMakePaymentModal} /></Elements>}
      </Container>
    </section>
  );
}


// WEBPACK FOOTER //
// ./src/components/membershipPlan/choosePlan.js